import { render, staticRenderFns } from "./MailingRecipientsListPreview.vue?vue&type=template&id=372ada6a"
import script from "./MailingRecipientsListPreview.vue?vue&type=script&lang=js"
export * from "./MailingRecipientsListPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports